export default __webpack_public_path__ + "static/media/bookig-stats.7df60679.svg";